module.exports = __webpack_public_path__ + "static/img/15-15.da9f75ff.jpeg";